<template>
  <div v-on:show-snackbar="initSnackbar" class="snackbar" class.bind="snackBar.class" if.bind="snackBar.visible">
    <span class="snackbar__description">${snackBar.message}</span>
    <button class="snackbar__button" click.delegate="snackBar.buttonFunction()" if.bind="snackBar.buttonText">${snackBar.buttonText}</button>
  </div>
</template>

<script>
  export default {
    data: function() {
      return {
        snackBar: null,
        snackBarTimeout: null,
      }
    },
    methods: {
      clearVisibleSnackbar: function() {
        this.snackBar = {
          buttonFunction: undefined,
          buttonText: undefined,
          class: undefined,
          message: undefined,
          type: undefined,
          visible: false,
        };
        clearTimeout(this.snackBarTimeout);
      },
      initSnackbar: function() {
        console.log("init snackbar called");
      }
    },
    mounted: function() {
      window.$swal = this.$swal;
    }
  }
</script>

<style lang="less">
  .snackbar {
    align-items: center;
    /*background-color: var(--night-rider);*/
    border-radius: 4px;
    /*box-shadow: @shadow-1;
    color: var(--white-smoke);*/
    bottom: 8px;
    display: flex;
    flex-direction: row;
    font-size: .875rem; // 14/16
    justify-content: space-between;
    min-height: 48px;
    left: 8px;
    opacity: 0;
    padding: 8px 16px;
    pointer-events: none;
    position: fixed;
    right: 8px;
    transition: opacity .5s ease-in-out;
    z-index: 21;

    &--button { padding: 0 8px 0 16px; }

    &--fab { bottom: 80px; }

    &--visible { opacity: 1; }

    &__button {
      border-radius: 4px;
      /*color: var(--saffron);*/
      font-size: .875rem; // 14/16
      font-weight: 600;
      letter-spacing: 1px;
      min-height: 36px;
      padding: 0 8px;
      pointer-events: auto;
      text-transform: uppercase;

      /*&:active,
      &:hover { background-color: lighten(@night-rider, 10%); }*/
    }

    &__description { color: inherit; }
  }

</style>